import React from "react";
import { motion } from "framer-motion";
import "./services.css";
import ServiceCard from "./ServiceCard";

const Services = () => {
  const services = [
    {
      icon: "twitter",
      title: "Twitter KOL Marketing",
      description:
        "Leverage influential crypto Twitter accounts to amplify your project's reach and engagement.",
      delay: 0.1,
    },
    {
      icon: "telegram",
      title: "Telegram Promotions",
      description:
        "Maximize visibility through strategic Telegram channel promotions and community engagement.",
      delay: 0.2,
    },
    {
      icon: "channel",
      title: "Private Channel Marketing",
      description:
        "Exclusive access to premium private channels with high-value crypto audiences.",
      delay: 0.3,
    },
    {
      icon: "youtube",
      title: "YouTube Collaborations",
      description:
        "Partner with top crypto YouTube creators for authentic content and brand awareness.",
      delay: 0.4,
    },
  ];

  return (
    <section className="services-section" id="services">
      <div className="services-container">
        {/* Intro Section */}
        <motion.div
          className="services-intro"
          initial={{ opacity: 1, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="services-heading">Our Services</h2>
          <p className="services-intro-text">
            We've been in the crypto marketing business for 2+ years, helping
            projects and prelaunches grow organically through influencer marketing.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              delay={service.delay}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
